import {
  APPLICANT_DETAILS_PATCH,
  APPLICANT_DETAILS_SUBMIT,
  CLEAR_STORE,
  COMPANY_ADDRESS_SUBMIT,
  COMPANY_DETAILS_SUBMIT,
  DELETE_REPRESENTATIVE,
  DESTROY_USER_STATE_INFO,
  PEOPLE_INFORMATION_KYC_SUBMIT,
  PERSONAL_DETAILS_SUBMIT,
  SAVE_SCREEN_NAME,
  UPDATE_MOBILE_NUMBER,
  USER_LOGGED_IN_STATE,
  USER_STATE_INFO,
  SET_INSTAPOINTS_LOGIC_DATA,
  SET_USER_ADDRESS_INFO,
  SET_USER_OTHER_DETAILS,
  STORE_ONFIDO_ACCESS_TOKEN_ERROR,
  SET_SEARCH_TEXT,
  SET_SEARCH_BOX_VISIBILITY,
  RESET_SEARCHBOX_DETAILS,
  SET_REQUIRED_DETAILS,
  STORE_ONFIDO_ACCESS_TOKEN,
  CLEAR_ONFIDO_TOKEN,
  SET_DROPDOWN_TEXT_VALUE,
  SET_USER_ADDRESS_ERROR,
  GET_ADDRESS_CONFIG,
  SET_BENE_DETAILS,
  TOGGLE_FEATURE_STATE,
  SET_AADHAR_DETAILS,
  SET_SAVED_AADHAR_DETAILS,
  SAVE_PLAID_PARAMS,
  SET_HELPCENTER_NOTIFICATION_DATA,
  TOGGLE_HELPCENTER_NOTIFICATION_STATE,
  STORE_BENE_LIST
} from '../../action-contants';
import { mergeObjectArray } from '../../../utils/library';

const INITIAL_STATE = {
  userloggedIn: { logged_in: false, data: {} },
  userStateInfo: [],
  instaPointsLogicData: null,
  onfidoError: false,
  otherDetails: {
    setRequiredFields: []
  },
  onfidoAccessToken: '',
  onfidoApplicantId: '',
  onfidoDocsToRender: [],
  userAddressInfo: {},
  userAddressError: null,
  dropdownTextValues: {},
  addressConfig: {
    loading: false,
    error: null,
    data: {}
  },
  beneDetails: {},
  aadharData: {},
  toggleFeature: { toggleFeature: false },
  plaidParams: null,
  helpCenterNotificationData: { help_center_notification: false },
  beneListData: null
};

export default function userDataReducer(state = INITIAL_STATE, action) {
  let userStateInfo, remitterDetails;
  switch (action.type) {
    case GET_ADDRESS_CONFIG: {
      return {
        ...state,
        addressConfig: { ...state.addressConfig, loading: true, error: null }
      };
    }
    case `${GET_ADDRESS_CONFIG}_SUCCESS`: {
      return {
        ...state,
        addressConfig: {
          ...state.addressConfig,
          loading: false,
          error: null,
          data: action.payload
        }
      };
    }
    case `${GET_ADDRESS_CONFIG}_ERROR`: {
      return {
        ...state,
        addressConfig: {
          ...state.addressConfig,
          loading: false,
          error: action.error,
          data: action.payload
        }
      };
    }
    //---------------------------------destroy actions------------------------------//
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case DESTROY_USER_STATE_INFO: {
      return { ...state, userStateInfo: {} };
    }
    case TOGGLE_FEATURE_STATE: {
      return { ...state, toggleFeature: action.data };
    }
    case APPLICANT_DETAILS_SUBMIT: {
      //response of applicant details and bulk get must be stored in asingle place
      remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, {
        remitter_corporate_representative_id: action.data.remitter_corporate_representative_id
      });
      userStateInfo = Object.assign({}, state.userStateInfo, {
        applicantDetails: {
          ...state.userStateInfo.applicantDetails,
          ...action.data
        },
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case APPLICANT_DETAILS_PATCH: {
      let representativeArray = [];
      const tempArray = [];
      tempArray.push(action.data);
      if (action.data.is_representative) {
        representativeArray = mergeObjectArray(
          state.userStateInfo.representatives,
          tempArray,
          'remitter_corporate_representative_id'
        );
        userStateInfo = Object.assign({}, state.userStateInfo, {
          applicantDetails: action.data,
          representatives: representativeArray
        });
      }
      userStateInfo = Object.assign({}, state.userStateInfo, {
        applicantDetails: action.data
      });
      return { ...state, userStateInfo };
    }
    case COMPANY_DETAILS_SUBMIT: {
      remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, action.data);
      userStateInfo = Object.assign({}, state.userStateInfo, {
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case COMPANY_ADDRESS_SUBMIT: {
      remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, action.data);
      userStateInfo = Object.assign({}, state.userStateInfo, {
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case PEOPLE_INFORMATION_KYC_SUBMIT: {
      let representativeArray = [];
      const tempArray = [];
      tempArray.push(action.data);
      representativeArray = mergeObjectArray(
        state.userStateInfo.representatives,
        tempArray,
        'remitter_corporate_representative_id'
      );
      userStateInfo = Object.assign({}, state.userStateInfo, {
        representatives: representativeArray
      });
      return { ...state, userStateInfo };
    }
    case SAVE_SCREEN_NAME: {
      remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, {
        screen_name: action.data.screen_name
      });
      userStateInfo = Object.assign({}, state.userStateInfo, {
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case PERSONAL_DETAILS_SUBMIT: {
      remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, action.data);
      userStateInfo = Object.assign({}, state.userStateInfo, {
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case DELETE_REPRESENTATIVE: {
      let representatives = [];
      representatives = representatives.concat(state.userStateInfo.representatives);
      representatives.forEach((key, index) => {
        if (key.remitter_corporate_representative_id === action.data.representative_id) {
          representatives.splice(index, 1);
          return;
        }
      });
      userStateInfo = Object.assign({}, state.userStateInfo, {
        representatives
      });
      return { ...state, userStateInfo };
    }
    case UPDATE_MOBILE_NUMBER: {
      const remitterDetails = Object.assign({}, state.userStateInfo.remitterDetails, {
        mobile_number: action.data
      });
      userStateInfo = Object.assign({}, state.userStateInfo, {
        remitterDetails
      });
      return { ...state, userStateInfo };
    }
    case USER_LOGGED_IN_STATE: {
      return { ...state, userloggedIn: action.data };
    }
    case USER_STATE_INFO: {
      return { ...state, userStateInfo: action.data };
    }
    case SET_USER_OTHER_DETAILS: {
      return {
        ...state,
        otherDetails: { ...state.otherDetails, ...action.data }
      };
    }
    case SET_INSTAPOINTS_LOGIC_DATA: {
      return { ...state, instaPointsLogicData: action.instaPointsLogicData };
    }
    case STORE_ONFIDO_ACCESS_TOKEN: {
      return { ...state, ...action.data };
    }
    case STORE_ONFIDO_ACCESS_TOKEN_ERROR: {
      return { ...state, onfidoError: action.data };
    }
    case CLEAR_ONFIDO_TOKEN: {
      return {
        ...state,
        onfidoAccessToken: '',
        onfidoApplicantId: '',
        onfidoDocsToRender: []
      };
    }
    case SET_USER_ADDRESS_INFO: {
      return {
        ...state,
        userAddressInfo: action.userAddressInfo
      };
    }
    case SET_USER_ADDRESS_ERROR: {
      return {
        ...state,
        userAddressError: action.error
      };
    }
    case SET_SEARCH_TEXT: {
      return {
        ...state,
        otherDetails: {
          ...state.otherDetails,
          searchBoxDetails: {
            ...state.otherDetails.searchBoxDetails,
            searchText: action.searchText
          }
        }
      };
    }
    case SET_SEARCH_BOX_VISIBILITY: {
      return {
        ...state,
        otherDetails: {
          ...state.otherDetails,
          searchBoxDetails: {
            searchText: '',
            isSearchBoxVisible: action.isSearchBoxVisible
          }
        }
      };
    }
    case RESET_SEARCHBOX_DETAILS: {
      return {
        ...state,
        otherDetails: {
          ...state.otherDetails,
          searchBoxDetails: {}
        }
      };
    }
    case SET_REQUIRED_DETAILS:
      return {
        ...state,
        otherDetails: {
          ...state.otherDetails,
          setRequiredFields: action.data
        }
      };
    case SET_DROPDOWN_TEXT_VALUE: {
      return {
        ...state,
        dropdownTextValues: { ...state.dropdownTextValues, ...action.textValue }
      };
    }
    case SET_BENE_DETAILS: {
      return {
        ...state,
        beneDetails: action.payload.beneDetails
      };
    }
    case STORE_BENE_LIST: {
      return {
        ...state,
        beneListData: action.data
      };
    }
    case SET_AADHAR_DETAILS: {
      return {
        ...state,
        aadharData: action.payload.data
      };
    }
    case SET_SAVED_AADHAR_DETAILS: {
      return {
        ...state,
        savedAadharData: action.payload.data
      };
    }
    case SAVE_PLAID_PARAMS: {
      return {
        ...state,
        plaidParams: action.payload.plaidParams
      };
    }
    case SET_HELPCENTER_NOTIFICATION_DATA: {
      return {
        ...state,
        helpCenterNotificationData: {
          ...state.helpCenterNotificationData,
          help_center_notification: action.helpCenterNotificationData
        }
      };
    }
    case TOGGLE_HELPCENTER_NOTIFICATION_STATE: {
      return {
        ...state,
        helpCenterNotificationData: {
          ...state.helpCenterNotificationData,
          help_center_notification: action.data.help_center_notification
        }
      };
    }
    default:
      return state;
  }
}
